(ns teamoesterreich.util.date
  (:require [teamoesterreich.util.log :as log :include-macros true]
            [cljs-time.core :as time]
            [cljs-time.coerce :as time-c]
            [cljs-time.format :as timef]))


(def zone-shift (time/hours (* -1 (/ (.getTimezoneOffset (js/Date.)) 60))))


(defn print-http [in]
  (when in
    (timef/unparse (timef/formatter "yyyyMMddTHHmmss.sssZ") in)))
(defn parse-http [in]
  (when in
    (timef/parse (timef/formatter "yyyyMMdd'T'HHmmss.SSSZ") in)))
(defn parse-http! [in]
  (try
    (parse-http in)
    (catch js/Error e nil)))

;(timef/parse (timef/formatter "yyyyMMddTHHmmss.sssZ") "20240318T224548.836Z")

(defn print-local-timestring [in]
  (when in
    (timef/unparse (timef/formatter "HH:mm") (time/plus (time-c/from-string in) zone-shift))))

(defn print-local [in]
  (when in
    (timef/unparse (timef/formatter "yyyy-MM-dd HH:mm") (time/plus (time-c/from-string in) zone-shift))))

(defn print-local-date [in]
  (when in
    (timef/unparse (timef/formatter "yyyy-MM-dd") (time/plus (time-c/from-string in) zone-shift))))


(defn parse-local-date [in]
  (when in
    (time/minus (timef/parse (timef/formatter "yyyy-MM-dd") in) zone-shift)))

(defn parse-unix-date [in]
  (when in
    (time-c/from-long in)))
(defn unix-date-2-date-form [in]
  (when in
    (timef/unparse (timef/formatter "yyyy-MM-dd'T'HH:mm") (time/plus (time-c/from-long in) zone-shift))))
(defn date-form-2-unix-date [in]
  (when in
    (time-c/to-long (time/minus (timef/parse (timef/formatter "yyyy-MM-dd'T'HH:mm") in) zone-shift))))


(defn parse-rest-time [in]
  (timef/parse (timef/formatter "yyyyMMdd'T'HHmmss.SSS'Z'") in))
(defn rest-2-date-field! [in]
  (try
    (timef/unparse (timef/formatter "yyyy-MM-dd") (parse-rest-time in))
    (catch :default e
      nil))
  )
(defn rest-2-datetime-field! [in]
  (try
    (timef/unparse (timef/formatter "yyyy-MM-dd HH:mm") (parse-rest-time in))
    (catch :default e
      nil))
  )
(defn date-field-2-rest [in]
  (timef/unparse (timef/formatter "yyyyMMdd'T'HHmmss.SSS'Z'") (timef/parse (timef/formatter "yyyy-MM-dd") in))
  )

(defn print-google-date [g-date]
  (timef/unparse (timef/formatter "yyyy-MM-dd HH:mm") g-date))

(defn print-format-g-date [g-date format]
  (timef/unparse (timef/formatter format) g-date))

(defn parse-service-date! [in]
  nil
  (try
    (time-c/from-string in)
    (catch js/Error e
      nil))
  )

(defn now []
  (time/now))


(defn date>? [a b]
  (time/before? b a)
  )

(defn date<? [a b]
  (time/before? a b)
  )



(defn print-local-fine [in]
  (when in
    (timef/unparse (timef/formatter "yyyy-MM-dd HH:mm:ss") (time/plus (time-c/from-string in) zone-shift))))


(defn print-local-short [in]
  (when in
    (timef/unparse (timef/formatter "dd.MM HH:mm") (time/plus (time-c/from-string in) zone-shift))))

;(.getTime (time/now))




(defn is-passed [in]
  (if in
    (< (.getTime (time-c/from-string in)) (.getTime (time/now)))
    true))

(defn is-soon [in]
  (if in
    (< (.getTime (time-c/from-string in)) (.getTime (time/plus (time/now) (time/months 3))))
    true))



(defn googDate->ger! [goog-date]
  (if (instance? goog.date.UtcDateTime goog-date)
    (str (.getDay goog-date) "." (inc (.getMonth goog-date)) "." (.getFullYear goog-date))
    "-"))

;(in-ns 'teamoesterreich.util.date)

;; (print (timef/parse (timef/formatter "yyyyMMdd'T'HHmmss.SSS'Z'") "19751031T110000.000Z"))